export const REGEXES_ORDER = [
    'enoughCharacters',
    'enoughLowercaseCharacters',
    'enoughUppercaseCharacters',
    'enoughNumbers',
];
export function getValidationResultsByRule(password, minLength) {
    const minLengthRegex = new RegExp(`^.{${minLength},}$`);
    const REGEXES = {
        enoughCharacters: minLengthRegex,
        enoughLowercaseCharacters: /(?=.*[a-z])/,
        enoughUppercaseCharacters: /(?=.*[A-Z])/,
        enoughNumbers: /(?=.*\d)/,
    };
    const result = {};
    REGEXES_ORDER.forEach((regexKey) => {
        const regex = REGEXES[regexKey];
        result[regexKey] = regex.test(password);
    });
    return result;
}
export function getIsValidPassword(password, minLength) {
    const validationResult = getValidationResultsByRule(password, minLength || 8);
    return !Object.values(validationResult).includes(false);
}
//# sourceMappingURL=validate.js.map